var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useRef, useState } from 'react';
export function useLazyResource(fetcher, initial = null) {
    const [data, setDataState] = useState(initial);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const latestRequest = useRef(0);
    const pending = useRef(0);
    const setData = (value) => {
        latestRequest.current += 1;
        setDataState(value);
    };
    const refresh = () => __awaiter(this, void 0, void 0, function* () {
        latestRequest.current += 1;
        const request = latestRequest.current;
        pending.current += 1;
        setLoading(true);
        setError(false);
        try {
            const value = yield fetcher();
            if (request === latestRequest.current)
                setDataState(value);
        }
        catch (_a) {
            if (request === latestRequest.current)
                setError(true);
        }
        finally {
            pending.current -= 1;
            setLoading(pending.current > 0);
        }
    });
    const load = () => {
        if (data === null && pending.current === 0)
            void refresh();
    };
    const reload = () => {
        if (pending.current === 0)
            void refresh();
    };
    return { data, setData, loading, error, load, refresh, reload };
}
